import script from "./top-bar.vue?vue&type=script&setup=true&lang=js"
export * from "./top-bar.vue?vue&type=script&setup=true&lang=js"
/* custom blocks */
import block0 from "./top-bar.vue?vue&type=custom&index=0&blockType=i18n&lang=json"
if (typeof block0 === 'function') block0(script)


const __exports__ = script;

export default __exports__